import { render, staticRenderFns } from "./testConsult.vue?vue&type=template&id=e7b1aef6&scoped=true"
import script from "./testConsult.vue?vue&type=script&lang=js"
export * from "./testConsult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b1aef6",
  null
  
)

export default component.exports